export default __webpack_public_path__ + "static/media/Sword of the Old Commander.66e2e6a8.jpg";